import React from 'react';
import { Popper, ClickAwayListener, Paper, PopperPlacementType, Fade } from '@mui/material';
import { PopperProps } from '@mui/material/Popper/BasePopper.types';


type ContentProps = {
  closeDropdown: () => void;
}

export type DropdownProps = {
  content: React.ReactElement | ((props: ContentProps) => React.ReactElement);
  placement?: PopperPlacementType;
  children: (props: {
    ref: React.RefObject<HTMLButtonElement | null>;
    handleToggleDropdownMenu: () => void;
    openDropdownMenu: boolean;
  }) => React.ReactElement;
  slotProps?: {
    popper?: Partial<PopperProps>;
  }
}

export const Dropdown: React.FC<DropdownProps> = ({ children, content, placement, slotProps }) => {

  const [openDropdownMenu, setOpenDropdownMenu] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleToggleDropdownMenu = React.useCallback(() => {
    setOpenDropdownMenu((prevOpen) => !prevOpen);
  }, []);

  const handleClose = React.useCallback(() => {
    setOpenDropdownMenu(false);
  }, []);

  return (
    <React.Fragment>
      {children({
        ref: anchorRef,
        handleToggleDropdownMenu,
        openDropdownMenu,
      })}
      <Popper
        {...slotProps?.popper}
        open={openDropdownMenu}
        anchorEl={anchorRef.current}
        role={undefined}
        placement={placement}
        style={{ zIndex: 1300 }}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper elevation={2}>
              <ClickAwayListener onClickAway={handleClose}>
                {typeof content === 'function' ? content({ closeDropdown: handleClose }) : content}
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </React.Fragment>
  );
};
